import { cn, Typography } from "@suraasa/placebo-ui"
import { motion } from "framer-motion"

const SuccessFormSubmit = ({
  title,
  description,
  className,
}: {
  title?: string
  description?: string
  className?: string
}) => {
  return (
    <div
      className={cn(
        "flex w-full flex-col items-center justify-center  text-center",
        className
      )}
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{
          type: "spring",
          stiffness: 200,
          damping: 20,
          duration: 0.2,
        }}
        className="relative mb-2.75 size-12"
      >
        <motion.div
          className="absolute inset-0 rounded-full bg-[#E5F4F1]"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.2 }}
        />
        <motion.svg
          viewBox="0 0 24 24"
          className="absolute inset-0 size-full p-2"
          initial="hidden"
          animate="visible"
        >
          <motion.path
            d="M4 12.6111L8.92308 17.5L20 6.5"
            fill="transparent"
            strokeWidth="2.5"
            stroke="#38A169"
            strokeLinecap="round"
            strokeLinejoin="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{
              delay: 0.2,
              type: "spring",
              stiffness: 100,
              duration: 0.8,
            }}
          />
        </motion.svg>
      </motion.div>
      {title && (
        <Typography variant="title2" className="mb-2 text-onSurface-900">
          {title}
        </Typography>
      )}
      {description && (
        <Typography className="max-w-[404px] text-onSurface-600">
          {description}
        </Typography>
      )}
    </div>
  )
}

export default SuccessFormSubmit
